import { initErrorMetrics } from './daemon/initErrorMetrics';
import { initSpeculationRules } from './daemon/initSpeculationRules';
import { runMetricsDaemon } from './daemon/runMetricsDaemon';
import { MetricsFactory } from './MetricsFactory';
function createMetricsFactory(namespace, options = {}) {
  if (!namespace) {
    throw new Error('[metrics-js] A namespace is required for a Metrics factory.');
  }
  runMetricsDaemon();
  initErrorMetrics();
  initSpeculationRules();
  const dimensions = options.dimensions || {};
  if (options.library) {
    dimensions.fe_library = options.library;
  }
  if (options.consumerPackage) {
    dimensions.fe_consumer_package = options.consumerPackage;
  }
  return new MetricsFactory(namespace, dimensions);
}
export { createMetricsFactory };